import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import MUIAutoComplete from 'material-ui/AutoComplete';
import { TextField, AutoComplete } from 'redux-form-material-ui';

import StopAdder from './StopAdder';

class ManifestForm extends Component {
  static validate(values) {
    const errors = {};

    return errors;
  }

  static propTypes = {
    drivers: PropTypes.array.isRequired,
    units: PropTypes.array.isRequired,
    trailers: PropTypes.array.isRequired,
    orders: PropTypes.array.isRequired,
  };

  renderTextField = props => (
    <TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...props} fullWidth />
  );

  render() {
    const { handleSubmit, submitting, orders, drivers, units, trailers } = this.props;
    const buttonText = (submitting) ? 'Saving...' : 'Save';

    const drs = drivers.map(item => item.name);
    const unts = units.map(item => item.name);
    const trls = trailers.map(item => item.name);

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12">
            <Field name="deliveryDate" floatingLabelText="Delivery Date" component={DatePicker} />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4">
            <Field name="driver" component={AutoComplete} dataSource={drs} filter={MUIAutoComplete.fuzzyFilter} floatingLabelText="Driver" fullWidth />
          </div>
          <div className="col s12 m4">
            <Field name="unit" component={AutoComplete} dataSource={unts} filter={MUIAutoComplete.fuzzyFilter} floatingLabelText="Unit" fullWidth />
          </div>
          <div className="col s12 m4">
            <Field name="trailer" component={AutoComplete} dataSource={trls} filter={MUIAutoComplete.fuzzyFilter} floatingLabelText="Trailer" fullWidth />
          </div>
        </div>
        <div className="row">
          <div className="col s12">Select 1 or more locations to stop at</div>
        </div>
        <div className="row">
          <div className="col s12">
            <Field name="stops" component={StopAdder} orders={orders} fullWidth />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m8" />
          <div className="col s12 m4">
            <RaisedButton fullWidth onClick={handleSubmit} disabled={submitting}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'manifestForm',
  validate: ManifestForm.validate
})(ManifestForm);


// WEBPACK FOOTER //
// ./src/components/Dispatcher/Manifests/Edit.js